import { useEffect, useState } from "react";
import { DesktopInstallWizard } from "./DesktopInstallWizard";
import { registerDesktopInstallWizard } from "../../lib/start-godo-desktop-install";

/** Global install wizard opened after «تنزيل Install». */
export function DesktopInstallHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => registerDesktopInstallWizard(() => setOpen(true)), []);

  return <DesktopInstallWizard open={open} onClose={() => setOpen(false)} />;
}
